import Button from '@app/components/Button';
import { CaptionStartError600 } from '@app/components/Text';
import styled from '@emotion/styled';
import React, { FC } from 'react';

interface Props {
  cancelId: string;
  saveId: string;
  hasChanges: boolean;
  maxChanges: number;
  exceedsMaxChanges: boolean;
  isSaving: boolean;
  isCancelDisabled?: boolean;
  onCancel(): void;
  onSave(): void;
}

const SaveCancelActions: FC<Props> = ({
  cancelId,
  saveId,
  hasChanges,
  maxChanges,
  exceedsMaxChanges,
  isSaving,
  isCancelDisabled,
  onCancel,
  onSave,
}) => (
  <ActionsLine>
    {exceedsMaxChanges && <CaptionStartError600.div>Save up to {maxChanges} changes at a time</CaptionStartError600.div>}
    <Button id={cancelId} appearance='outline' colorScheme='primary' disabled={isSaving || isCancelDisabled} onClick={onCancel}>
      CANCEL
    </Button>
    <Button id={saveId} colorScheme='primary' disabled={!hasChanges || exceedsMaxChanges} loading={isSaving} onClick={onSave}>
      SAVE
    </Button>
  </ActionsLine>
);

export default SaveCancelActions;

const ActionsLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  flex: 0 0 auto;
  gap: 12px;

  margin-top: 16px;
`;
